// src/features/authV2/config/config.tsx

import { LogoVk } from "@app/assets/Icons";
import { FaApple, FaFacebook, FaGoogle } from "react-icons/fa";

import { LoginProvider } from "../lib/types.ts";

/**
 * @interface SocialProviderConfig
 * @description Конфигурация для кнопки социального входа.
 */
export interface SocialProviderConfig {
	provider: LoginProvider;
	label: string;
	icon: React.ReactNode;
	// Можно добавить любые другие поля, например, для стилизации
	style?: React.CSSProperties;
}

/**
 * Конфигурация кнопок социальных сетей.
 * Чтобы добавить или удалить кнопку, просто измените этот массив.
 * Новые провайдеры 'facebook' и 'vk' добавлены.
 */
export const socialProviders: SocialProviderConfig[] = [
	{
		provider: "google",
		label: "Google",
		icon: <FaGoogle />
	},
	{
		provider: "apple",
		label: "Apple",
		icon: <FaApple />
	},
	{
		provider: "facebook",
		label: "Facebook",
		icon: <FaFacebook />
	},
	{
		provider: "vk",
		label: "VK",
		icon: <LogoVk />
	}
];
